<div class="psxtra-tag">
    <img src="/assets/icons/crown-icon.svg" alt="">
    {{ "addOn.exclusivePS" | translate }}
</div>